import { MapViewState } from '@deck.gl/core'
import { cellToBoundary, latLngToCell } from 'h3-js'
import turfBBox from '@turf/bbox'
import distance from '@turf/distance'
import { point } from '@turf/helpers'
import { DEFAULT_TILE_SIZE } from '../ui/builderConstants'
import { _getHexagonResolution } from '@carto/api-client'

const zeroPad = (fullLen: number, numStr: string): string => {
  const numZeroes = fullLen - numStr.length
  let outStr = ''
  for (let i = 0; i < numZeroes; i++) {
    outStr += '0'
  }
  outStr = outStr + numStr
  return outStr
}

// See: https://github.com/uber/h3-js/blob/9a20295a2377f415ecc3ef6ad50410f948bfbeb2/lib/h3core.js#L99
export const hexFrom32Bit = (num: number | bigint): string => {
  if (num >= 0 || typeof num === 'bigint') {
    return num.toString(16)
  }

  // Handle negative numbers
  num = num & 0x7fffffff
  let tempStr = zeroPad(8, num.toString(16))
  const topNum = (parseInt(tempStr[0], 16) + 8).toString(16)
  tempStr = topNum + tempStr.substring(1)
  return tempStr
}

export function getApproximateH3CellSizeKm({
  mapState,
  aggregationResLevel
}: {
  mapState: MapViewState
  aggregationResLevel: number
}) {
  const hexagonBaseResolution = _getHexagonResolution(mapState, DEFAULT_TILE_SIZE)
  const resolution = Math.ceil(hexagonBaseResolution + aggregationResLevel)

  const h3CellIndex = latLngToCell(mapState.latitude, mapState.longitude, resolution)

  const boundary = cellToBoundary(h3CellIndex, true)
  const boundingBox = turfBBox({ type: 'LineString', coordinates: boundary })

  const leftTop = point([boundingBox[0], boundingBox[1]])
  const rightTop = point([boundingBox[2], boundingBox[1]])
  const leftBottom = point([boundingBox[0], boundingBox[3]])

  const d0 = distance(leftTop, rightTop, { units: 'kilometers' })
  const d1 = distance(rightTop, leftBottom, { units: 'kilometers' })
  return Math.max(d0, d1)
}
